import { ICreateApk, IEditApk, IGetPaginatedApk, IGetPaginatedApkForAssign, IAssignApk } from 'types';
import {
	serviceGetApkInfo,
	serviceCreateApk,
	serviceUpdateApk,
	serviceGetPaginatedApk,
	serviceDeleteApk,
	serviceGetPaginatedApkForAssign,
	serviceGetCustomersForAssignApk,
	serviceGetRestaurantsByIDsCustomersForApk,
	serviceGetApkByIDsRestaurantsForApk,
	serviceAssignApk,
} from 'services/api/apk';
import { createAppErrorMessage } from 'utils/helpers';

const getApkInfo = async (apkID: string) => {
	try {
		const response = await serviceGetApkInfo(apkID);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const createApk = async (data: ICreateApk) => {
	try {
		await serviceCreateApk(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorCreatingTabletApp');
		throw new Error(errorMessage);
	}
};

const editApk = async (data: IEditApk) => {
	try {
		await serviceUpdateApk(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingTabletApp');
		throw new Error(errorMessage);
	}
};

const getPaginatedApk = async (args: IGetPaginatedApk) => {
	try {
		const response = await serviceGetPaginatedApk(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const deleteApk = async (apkID: string) => {
	try {
		await serviceDeleteApk(apkID);
	} catch (err) {
		throw err;
	}
};

const getPaginatedApkForAssign = async (args: IGetPaginatedApkForAssign) => {
	try {
		const response = await serviceGetPaginatedApkForAssign(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const getCustomersForAssignApk = async () => {
	try {
		const response = await serviceGetCustomersForAssignApk();
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const getRestaurantsByIDsCustomersForApk = async (customerIDs: string[]) => {
	try {
		const response = await serviceGetRestaurantsByIDsCustomersForApk(customerIDs);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};

const getRestaurantsByIDsRestaurantsForApk = async (restaurantIDs: string[]) => {
	try {
		const response = await serviceGetApkByIDsRestaurantsForApk(restaurantIDs);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};

const assignApk = async (data: IAssignApk[]) => {
	try {
		await serviceAssignApk(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorAssignTabletApp');
		throw new Error(errorMessage);
	}
};

export {
	getApkInfo,
	createApk,
	editApk,
	getPaginatedApk,
	deleteApk,
	getPaginatedApkForAssign,
	getCustomersForAssignApk,
	getRestaurantsByIDsCustomersForApk,
	getRestaurantsByIDsRestaurantsForApk,
	assignApk,
};
